import { AnalyticsService } from '@services/analytics/analytics.service';
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appCta]'
})
export class CtaDirective {
  @Input() appCta: 'page' | 'popup' = 'page';

  constructor(
    private el: ElementRef<HTMLIonButtonElement>,
    private analyticsService: AnalyticsService
  ) {}

  @HostListener('click')
  onClick() {
    this.pushEvent();
  }

  private pushEvent(): void {
    if (this.appCta === 'popup') {
      this.analyticsService.pushPopupCtaClickEvent({
        text: this.el.nativeElement.textContent
      });
    } else {
      this.analyticsService.pushCtaClickEvent({
        text: this.el.nativeElement.textContent,
        class: this.el.nativeElement.className
      });
    }
  }
}
